package fr.manyverse.app.domain.image

import fr.manyverse.app.domain.model.ImageData

/**
 * Conditionally optimizes an image before upload according to these rules:
 * - webp, size ≤ maxDimension → returned unchanged
 * - webp, size > maxDimension → resized, format preserved
 * - other format, size ≤ maxDimension → converted to webp, no resize
 * - other format, size > maxDimension → resized and converted to webp
 */
interface ImageOptimizer {
    suspend fun optimize(
        image: ImageData,
        maxDimension: Int = DEFAULT_MAX_DIMENSION,
        quality: Int = DEFAULT_QUALITY
    ): Result<ImageData>

    companion object {
        const val DEFAULT_MAX_DIMENSION: Int = 1920
        const val DEFAULT_QUALITY: Int = 80
    }
}
